define(['angular', 'angular-resource', '../models/settings'], function (
    angular
) {
    return angular
        .module('settingsServices', ['ngResource', 'settingsModels'])
        .factory('Settings', [
            '$resource',
            '$rootScope',
            'SettingsModel',
            function ($resource, $rootScope, SettingsModel) {
                var resource = $resource(
                    $rootScope.Routing.generate('leads', { _format: 'json' }),
                    [],
                    {
                        get: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('settings', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse settings as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new SettingsModel(modelData);
                            },
                        },
                        update: {
                            method: 'PUT',
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('update_settings', {
                                    _format: 'json',
                                })
                            ),
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse settings as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new SettingsModel(modelData);
                            },
                        },
                    }
                );

                var settings = false;
                var loadSettings = true;
                return {
                    getSettings: function (reload, callback) {
                        if (reload || loadSettings) {
                            settings = resource.get();
                            loadSettings = false;
                        }
                        if (typeof callback == 'function') {
                            settings.$promise.then(callback);
                        }
                        return settings;
                    },
                };
            },
        ]);
});
